/*
Particle Board

--moistureResistant <boolean::checkbox>
--fireRated <boolean::checkbox>
--manufacturers {
  --manufacturer <Manufacturer>
  --manufacturerNumber <string>
  --computerEaseNumber <string>
}
*/
import {
  moistureResistant,
  fireRated,
  sheetStockHeaders
} from '@/modules/standardItems/schemas/sheetStock/headers'

export default [
  ...sheetStockHeaders(),
  moistureResistant(),
  fireRated()
]
